import svgPaths from "./svg-x94mz06laa";
import clsx from "clsx";
// Placeholder images
const imgContentCreatorLogo1 = "https://placehold.co/116x26?text=Logo";
const imgImage43 = "https://placehold.co/280x164?text=Image+43";
const imgImage44 = "https://placehold.co/280x164?text=Image+44";
const imgImage45 = "https://placehold.co/280x164?text=Image+45";
const imgImage18 = "https://placehold.co/256x120?text=Image+18";
const imgImage17 = "https://placehold.co/256x120?text=Image+17";
const imgImage16 = "https://placehold.co/256x120?text=Image+16";
const imgImage19 = "https://placehold.co/256x120?text=Image+19";
const imgImage5 = "https://placehold.co/256x120?text=Image+5";

function Wrapper4({ children }: React.PropsWithChildren) {
  return (
    <div className="h-[210px] relative rounded-[8px] shrink-0 w-[280px]">
      <div className="overflow-clip relative rounded-[inherit] size-full">{children}</div>
      <div aria-hidden="true" className="absolute border border-[#e4e7ec] border-solid inset-0 pointer-events-none rounded-[8px]" />
    </div>
  );
}

function Wrapper3({ children }: React.PropsWithChildren) {
  return (
    <div className="relative shrink-0 size-[18px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 18 18">
        {children}
      </svg>
    </div>
  );
}
type Wrapper2Props = {
  additionalClassNames?: string;
};

function Wrapper2({ children, additionalClassNames = "" }: React.PropsWithChildren<Wrapper2Props>) {
  return (
    <div className={clsx("relative size-[20px]", additionalClassNames)}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 20 20">
        {children}
      </svg>
    </div>
  );
}

function Wrapper1({ children }: React.PropsWithChildren) {
  return (
    <div className="relative shrink-0 size-[16px]">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 16 16">
        {children}
      </svg>
    </div>
  );
}

function Wrapper({ children }: React.PropsWithChildren) {
  return (
    <Wrapper1>
      <g id="Frame">{children}</g>
    </Wrapper1>
  );
}
type Helper22PxTextProps = {
  text: string;
  additionalClassNames?: string;
};

function Helper22PxText({ text, additionalClassNames = "" }: Helper22PxTextProps) {
  return (
    <div className={clsx("absolute bg-[#eaf6ec] content-stretch flex gap-[4px] h-[20px] items-center justify-center px-[8px] py-[10px] rounded-[4px] top-[6px]", additionalClassNames)}>
      <div aria-hidden="true" className="absolute border border-[#6fc482] border-solid inset-0 pointer-events-none rounded-[4px]" />
      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[22px] relative shrink-0 text-[#165c26] text-[12px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
        {text}
      </p>
    </div>
  );
}
type Text1Props = {
  text: string;
};

function Text1({ text }: Text1Props) {
  return (
    <div style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }} className="flex flex-col font-['Bricolage_Grotesque:ExtraBold',sans-serif] font-extrabold justify-center leading-[0] relative shrink-0 text-[#101928] text-[18px] text-nowrap">
      <p className="leading-[normal]">{text}</p>
    </div>
  );
}
type TextProps = {
  text: string;
  additionalClassNames?: string;
};

function Text({ text, additionalClassNames = "" }: TextProps) {
  return (
    <div className={clsx("bg-[rgba(255,255,255,0.3)] content-stretch flex items-center justify-between p-[8px] relative rounded-[4px] shrink-0", additionalClassNames)}>
      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[normal] relative shrink-0 text-[#101928] text-[13px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
        {text}
      </p>
      <Wrapper>
        <path d="M4 6L8 10L12 6" id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
      </Wrapper>
    </div>
  );
}
type YellowBgProps = {
  additionalClassNames?: string;
};

function YellowBg({ additionalClassNames = "" }: YellowBgProps) {
  return (
    <div className={clsx("absolute h-[75px] w-[76px]", additionalClassNames)}>
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 76 75">
        <g id="Yellow BG">
          <g filter="url(#filter0_f_158_757)" id="Ellipse 2361" opacity="0">
            <ellipse cx="38" cy="37.5" fill="url(#paint0_linear_158_757)" rx="38" ry="37.5" />
          </g>
        </g>
        <defs>
          <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="-inf" id="filter0_f_158_757" width="-inf" x="inf" y="inf">
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_158_757" stdDeviation="75" />
          </filter>
          <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_158_757" x1="38" x2="38" y1="0" y2="75">
            <stop stopColor="#0BA29B" />
            <stop offset="1" stopColor="#43B48D" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

interface GeneratedImageProps {
  onHomeClick?: () => void;
}

export default function GeneratedImage({ onHomeClick }: GeneratedImageProps) {
  return (
    <div className="bg-white relative size-full" data-name="Generated Image">
      <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-[22px] top-[16px] w-[1397px]">
        <div className="h-[72px] relative rounded-[8px] shrink-0 w-full">
          <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
            <div className="content-stretch flex items-center justify-between px-[16px] py-[12px] relative size-full">
              <div className="h-[26px] relative shrink-0 w-[116px]" data-name="Content Creator logo 1">
                <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover pointer-events-none size-full" src={imgContentCreatorLogo1} />
              </div>
              <div className="bg-white h-[48px] relative rounded-[6px] shrink-0 w-[447px]" data-name="Top Bar - Content Creator">
                <div className="content-stretch flex flex-col items-start justify-center overflow-clip px-[7px] py-[6px] relative rounded-[inherit] size-full">
                  <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
                    <div
                      onClick={onHomeClick}
                      className="content-stretch flex gap-[2px] items-center justify-center p-[10px] relative rounded-[4px] shrink-0 cursor-pointer hover:bg-gray-100 transition-colors"
                    >
                      <Wrapper1>
                        <g id="Home">
                          <path d={svgPaths.p3a151200} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d={svgPaths.p18af2500} id="Vector_2" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                      </Wrapper1>
                      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[36px] relative shrink-0 text-[#101928] text-[13px] text-center text-nowrap tracking-[-0.26px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                        Home
                      </p>
                    </div>
                    <div className="content-stretch flex gap-[2px] items-center justify-center p-[10px] relative rounded-[6px] shrink-0 w-[102px]">
                      <Wrapper1>
                        <g id="Templates">
                          <path d={svgPaths.p118e9580} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d={svgPaths.p15fb5e00} id="Vector_2" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d={svgPaths.p17f25d40} id="Vector_3" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                      </Wrapper1>
                      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[36px] relative shrink-0 text-[#1d2739] text-[13px] text-center text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                        Templates
                      </p>
                    </div>
                    <div className="content-stretch flex gap-[2px] items-center justify-center p-[10px] relative rounded-[6px] shrink-0 w-[96px]">
                      <Wrapper1>
                        <g id="Brand Kit">
                          <path d={svgPaths.p33787900} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d={svgPaths.p25777a1e} id="Vector_2" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M4.66667 11.3333H4.67556" id="Vector_3" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                          <path d={svgPaths.pdd8f300} id="Vector_4" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                      </Wrapper1>
                      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[36px] relative shrink-0 text-[#1d2739] text-[13px] text-center text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                        Brand Kit
                      </p>
                    </div>
                    <div className="content-stretch flex gap-[2px] items-center justify-center p-[10px] relative rounded-[6px] shrink-0 w-[112px]">
                      <Wrapper1>
                        <g id="My Projects">
                          <path d={svgPaths.p1f315b00} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
                        </g>
                      </Wrapper1>
                      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[36px] relative shrink-0 text-[#1d2739] text-[13px] text-center text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                        My Projects
                      </p>
                    </div>
                  </div>
                </div>
                <div aria-hidden="true" className="absolute border-[#e4e7ec] border-[0.75px] border-solid inset-0 pointer-events-none rounded-[6px]" />
              </div>
              <div className="content-stretch flex gap-[16px] items-center relative shrink-0">
                <div className="bg-[#f9fafb] relative rounded-[6px] shrink-0 w-[32px]">
                  <div className="content-stretch flex flex-col items-center justify-center overflow-clip px-[8px] py-[6px] relative rounded-[inherit] w-full">
                    <Wrapper2 additionalClassNames="shrink-0">
                      <g clipPath="url(#clip0_158_821)" id="Frame">
                        <path d={svgPaths.p15c5ce00} id="Vector" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                        <path d={svgPaths.p3afab400} id="Vector_2" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                        <path d="M10 14.167H10.01" id="Vector_3" stroke="var(--stroke-0, #101928)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                      </g>
                      <defs>
                        <clipPath id="clip0_158_821">
                          <rect fill="white" height="20" width="20" />
                        </clipPath>
                      </defs>
                    </Wrapper2>
                  </div>
                  <div aria-hidden="true" className="absolute border-[#e4e7ec] border-[0.75px] border-solid inset-0 pointer-events-none rounded-[6px]" />
                </div>
                <div className="bg-[#f9fafb] h-[32px] relative rounded-[6px] shrink-0 w-[57px]">
                  <div className="content-stretch flex gap-[6px] items-center justify-center overflow-clip px-[8px] py-[6px] relative rounded-[inherit] size-full">
                    <div className="bg-[#2c9944] content-stretch flex flex-col items-center justify-center p-[6px] relative rounded-[100px] shrink-0 size-[24px]">
                      <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[36px] relative shrink-0 text-[13px] text-center text-nowrap text-white tracking-[0.26px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                        A
                      </p>
                    </div>
                    <Wrapper>
                      <path d="M4 6L8 10L12 6" id="Vector" stroke="var(--stroke-0, #1D2739)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                    </Wrapper>
                  </div>
                  <div aria-hidden="true" className="absolute border-[#e4e7ec] border-[0.75px] border-solid inset-0 pointer-events-none rounded-[6px]" />
                </div>
              </div>
            </div>
          </div>
          <div aria-hidden="true" className="absolute border-[#e4e7ec] border-[0.75px] border-solid inset-0 pointer-events-none rounded-[8px]" />
        </div>
        <div className="content-stretch flex flex-col gap-[40px] items-start relative shrink-0 w-full">
          <div className="h-[256px] overflow-clip relative rounded-[8px] shrink-0 w-[1397px]">
            <div className="absolute flex h-[285.872px] items-center justify-center left-[175.79px] top-[-15.01px] w-[157.459px]" style={{ "--transform-inner-width": "300", "--transform-inner-height": "150" } as React.CSSProperties}>
              <div className="flex-none rotate-[23.797deg]">
                <div className="h-[293.652px] relative w-[42.592px]">
                  <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 32 32">
                    <g id="Rectangle 34624130"></g>
                  </svg>
                </div>
              </div>
            </div>
            <div className="absolute h-[385px] left-[-42px] top-[-271px] w-[513px]">
              <div className="absolute inset-[-129.87%_-97.47%]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1513 1385">
                  <g filter="url(#filter0_f_58_750)" id="Ellipse 20">
                    <ellipse cx="756.5" cy="692.5" fill="var(--fill-0, #F9D495)" rx="256.5" ry="192.5" />
                  </g>
                  <defs>
                    <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="1385" id="filter0_f_58_750" width="1513" x="0" y="0">
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                      <feGaussianBlur result="effect1_foregroundBlur_58_750" stdDeviation="250" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="absolute h-[369px] right-0 top-[-224px] w-[573px]">
              <div className="absolute inset-[-135.5%_-87.26%]">
                <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 1573 1369">
                  <g filter="url(#filter0_f_58_735)" id="Ellipse 21">
                    <ellipse cx="786.5" cy="684.5" fill="var(--fill-0, #BEA4F3)" rx="286.5" ry="184.5" />
                  </g>
                  <defs>
                    <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="1369" id="filter0_f_58_735" width="1573" x="0" y="0">
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
                      <feGaussianBlur result="effect1_foregroundBlur_58_735" stdDeviation="250" />
                    </filter>
                  </defs>
                </svg>
              </div>
            </div>
            <div className="absolute h-[256px] left-0 overflow-clip top-0 w-[1397px]">
              <YellowBg additionalClassNames="left-0 top-0" />
              <YellowBg additionalClassNames="left-0 top-[75px]" />
              <YellowBg additionalClassNames="left-0 top-[150px]" />
              <YellowBg additionalClassNames="left-0 top-[225px]" />
              <YellowBg additionalClassNames="left-[152px] top-0" />
              <YellowBg additionalClassNames="left-[152px] top-[75px]" />
              <YellowBg additionalClassNames="left-[152px] top-[150px]" />
              <YellowBg additionalClassNames="left-[152px] top-[225px]" />
              <YellowBg additionalClassNames="left-[304px] top-0" />
              <YellowBg additionalClassNames="left-[304px] top-[75px]" />
              <YellowBg additionalClassNames="left-[304px] top-[150px]" />
              <YellowBg additionalClassNames="left-[304px] top-[225px]" />
              <YellowBg additionalClassNames="left-[456px] top-0" />
              <YellowBg additionalClassNames="left-[456px] top-[75px]" />
              <YellowBg additionalClassNames="left-[456px] top-[150px]" />
              <YellowBg additionalClassNames="left-[456px] top-[225px]" />
              <YellowBg additionalClassNames="left-[76px] top-0" />
              <YellowBg additionalClassNames="left-[76px] top-[75px]" />
              <YellowBg additionalClassNames="left-[76px] top-[150px]" />
              <YellowBg additionalClassNames="left-[76px] top-[225px]" />
              <YellowBg additionalClassNames="left-[228px] top-0" />
              <YellowBg additionalClassNames="left-[228px] top-[75px]" />
              <YellowBg additionalClassNames="left-[228px] top-[150px]" />
              <YellowBg additionalClassNames="left-[228px] top-[225px]" />
              <YellowBg additionalClassNames="left-[380px] top-0" />
              <YellowBg additionalClassNames="left-[380px] top-[75px]" />
              <YellowBg additionalClassNames="left-[380px] top-[150px]" />
              <YellowBg additionalClassNames="left-[380px] top-[225px]" />
              <YellowBg additionalClassNames="left-[532px] top-0" />
              <YellowBg additionalClassNames="left-[532px] top-[75px]" />
              <YellowBg additionalClassNames="left-[532px] top-[150px]" />
              <YellowBg additionalClassNames="left-[532px] top-[225px]" />
              <YellowBg additionalClassNames="left-[608px] top-0" />
              <YellowBg additionalClassNames="left-[684px] top-0" />
              <YellowBg additionalClassNames="left-[760px] top-0" />
              <YellowBg additionalClassNames="left-[836px] top-0" />
              <YellowBg additionalClassNames="left-[912px] top-0" />
              <YellowBg additionalClassNames="left-[988px] top-0" />
              <YellowBg additionalClassNames="left-[1064px] top-0" />
              <YellowBg additionalClassNames="left-[1140px] top-0" />
              <YellowBg additionalClassNames="left-[1216px] top-0" />
              <YellowBg additionalClassNames="left-[1292px] top-0" />
              <YellowBg additionalClassNames="left-[1368px] top-0" />
              <YellowBg additionalClassNames="left-[608px] top-[150px]" />
              <YellowBg additionalClassNames="left-[684px] top-[150px]" />
              <YellowBg additionalClassNames="left-[760px] top-[150px]" />
              <YellowBg additionalClassNames="left-[836px] top-[150px]" />
              <YellowBg additionalClassNames="left-[912px] top-[150px]" />
              <YellowBg additionalClassNames="left-[988px] top-[150px]" />
              <YellowBg additionalClassNames="left-[1064px] top-[150px]" />
              <YellowBg additionalClassNames="left-[1140px] top-[150px]" />
              <YellowBg additionalClassNames="left-[1216px] top-[150px]" />
              <YellowBg additionalClassNames="left-[1292px] top-[150px]" />
              <YellowBg additionalClassNames="left-[1368px] top-[150px]" />
              <YellowBg additionalClassNames="left-[608px] top-[75px]" />
              <YellowBg additionalClassNames="left-[684px] top-[75px]" />
              <YellowBg additionalClassNames="left-[760px] top-[75px]" />
              <YellowBg additionalClassNames="left-[836px] top-[75px]" />
              <YellowBg additionalClassNames="left-[912px] top-[75px]" />
              <YellowBg additionalClassNames="left-[988px] top-[75px]" />
              <YellowBg additionalClassNames="left-[1064px] top-[75px]" />
              <YellowBg additionalClassNames="left-[1140px] top-[75px]" />
              <YellowBg additionalClassNames="left-[1216px] top-[75px]" />
              <YellowBg additionalClassNames="left-[1292px] top-[75px]" />
              <YellowBg additionalClassNames="left-[1368px] top-[75px]" />
              <YellowBg additionalClassNames="left-[608px] top-[225px]" />
              <YellowBg additionalClassNames="left-[684px] top-[225px]" />
              <YellowBg additionalClassNames="left-[760px] top-[225px]" />
              <YellowBg additionalClassNames="left-[836px] top-[225px]" />
              <YellowBg additionalClassNames="left-[912px] top-[225px]" />
              <YellowBg additionalClassNames="left-[988px] top-[225px]" />
              <YellowBg additionalClassNames="left-[1064px] top-[225px]" />
              <YellowBg additionalClassNames="left-[1140px] top-[225px]" />
              <YellowBg additionalClassNames="left-[1216px] top-[225px]" />
              <YellowBg additionalClassNames="left-[1292px] top-[225px]" />
              <YellowBg additionalClassNames="left-[1368px] top-[225px]" />
            </div>
            <div className="absolute content-stretch flex flex-col gap-[16px] items-start left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] w-[1349px]">
              <div className="content-stretch flex flex-col gap-[20px] items-start relative shrink-0 w-full">
                <div className="content-stretch flex items-center relative shrink-0 w-full">
                  <div className="basis-0 content-stretch flex flex-col gap-[20px] grow items-start min-h-px min-w-px relative shrink-0">
                    <p className="font-['Bricolage_Grotesque:ExtraBold',sans-serif] font-extrabold leading-[normal] relative shrink-0 text-[#1d2739] text-[28px] w-full" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                      Turn your thoughts into templates instantly.
                    </p>
                    <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[24px] relative shrink-0 text-[#667185] text-[14px] tracking-[0.14px] w-full" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                      Type an idea. Watch a template appear like magic. Customize and make it yours in moments.
                    </p>
                  </div>
                </div>
                <div className="content-stretch flex gap-[16px] items-center relative shrink-0 w-full">
                  <div className="bg-[rgba(255,255,255,0.3)] content-stretch flex h-[48px] items-center overflow-clip px-[12px] py-[3px] relative rounded-[12px] shrink-0 w-[1289px]" data-name="Search bar">
                    <div className="content-stretch flex gap-[8px] items-center relative shrink-0">
                      <Wrapper3>
                        <g id="ix:ai">
                          <path d={svgPaths.p21edb380} fill="var(--fill-0, #101928)" id="Vector" />
                        </g>
                      </Wrapper3>
                      <div className="content-stretch flex gap-[8px] items-center relative shrink-0">
                        <p className="font-['Bricolage_Grotesque:Medium',sans-serif] font-medium leading-[24px] relative shrink-0 text-[#667185] text-[13px] text-nowrap" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                          Got an idea? Drop it here and let the template magic begin!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#30a84b] content-stretch flex gap-[4px] items-center justify-center px-[16px] py-[14px] relative rounded-[6px] shrink-0 size-[44px]" data-name="Primary - Sm">
                    <div className="relative shrink-0 size-[24px]" data-name="Frame">
                      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24">
                        <g id="Frame">
                          <path d="M5 12H19" id="Vector" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
                          <path d="M12 5L19 12L12 19" id="Vector_2" stroke="var(--stroke-0, white)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.75" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content-stretch flex gap-[12px] items-start relative shrink-0">
                <Text text="Landscape" additionalClassNames="w-[122px]" />
                <Text text="16:9" additionalClassNames="w-[89px]" />
              </div>
            </div>
          </div>
          <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
            <div className="content-stretch flex gap-[4px] items-center relative shrink-0">
              <Wrapper3>
                <g clipPath="url(#clip0_158_760)" id="noto:rocket">
                  <path d={svgPaths.p27818900} fill="var(--fill-0, #CA2C31)" id="Vector" />
                  <path d={svgPaths.p3cf22700} fill="var(--fill-0, #A02422)" id="Vector_2" />
                  <path d={svgPaths.p19a1c5f0} fill="var(--fill-0, #CA2C31)" id="Vector_3" />
                  <path d={svgPaths.p4538000} fill="var(--fill-0, #F7D74D)" id="Vector_4" />
                  <path d={svgPaths.p45eb990} fill="var(--fill-0, #FBF0B4)" id="Vector_5" />
                  <path d={svgPaths.p342a3200} fill="var(--fill-0, #858585)" id="Vector_6" />
                  <path d={svgPaths.p13721b0} fill="var(--fill-0, #437687)" id="Vector_7" />
                  <path d={svgPaths.p37f47500} fill="var(--fill-0, #3F545F)" id="Vector_8" />
                  <path d={svgPaths.p13470700} fill="var(--fill-0, #8DAFBF)" id="Vector_9" />
                  <path d={svgPaths.p2ffed480} fill="var(--fill-0, #D83F22)" id="Vector_10" />
                  <path d={svgPaths.p3102e900} fill="var(--fill-0, #6896A5)" id="Vector_11" />
                  <path d={svgPaths.p14d7c270} fill="var(--fill-0, #A02422)" id="Vector_12" />
                  <path d={svgPaths.pb7cab00} fill="var(--fill-0, #B3E1EE)" id="Vector_13" />
                  <path d={svgPaths.p1c78eb00} fill="var(--fill-0, #ED6A65)" id="Vector_14" />
                  <path d={svgPaths.p3a1fa300} fill="var(--fill-0, #E1E1E1)" id="Vector_15" />
                  <path d={svgPaths.p269a9800} fill="var(--fill-0, #3F545F)" id="Vector_16" />
                  <path d={svgPaths.p35920f00} fill="var(--fill-0, #A02524)" id="Vector_17" />
                  <path d={svgPaths.p27608e00} fill="var(--fill-0, #CA2C31)" id="Vector_18" />
                  <path d={svgPaths.p2e284680} fill="var(--fill-0, white)" id="Vector_19" />
                  <path d={svgPaths.p33898490} fill="var(--fill-0, white)" id="Vector_20" opacity="0.5" />
                  <path d={svgPaths.pec34900} fill="var(--fill-0, white)" id="Vector_21" />
                </g>
                <defs>
                  <clipPath id="clip0_158_760">
                    <rect fill="white" height="18" width="18" />
                  </clipPath>
                </defs>
              </Wrapper3>
              <Text1 text="Generated Designs" />
            </div>
            <div className="content-stretch flex gap-[16px] items-center overflow-clip relative shrink-0">
              <div className="h-[164px] overflow-clip relative rounded-[8px] shrink-0 w-[280px]">
                <div className="absolute h-[164px] left-0 top-0 w-[280px]" data-name="image 43">
                  <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <img alt="" className="absolute h-full left-[-0.1%] max-w-none top-0 w-[104.13%]" src={imgImage43} />
                  </div>
                </div>
              </div>
              <div className="h-[164px] overflow-clip relative rounded-[8px] shrink-0 w-[280px]">
                <div className="absolute h-[164px] left-0 top-0 w-[280px]" data-name="image 44">
                  <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <img alt="" className="absolute h-[100.15%] left-[-2.14%] max-w-none top-[-0.08%] w-[104.29%]" src={imgImage44} />
                  </div>
                </div>
              </div>
              <div className="h-[164px] overflow-clip relative rounded-[8px] shrink-0 w-[280px]">
                <div className="absolute h-[164px] left-[2px] top-0 w-[277px]" data-name="image 45">
                  <div className="absolute inset-0 overflow-hidden pointer-events-none">
                    <img alt="" className="absolute h-[100.15%] left-[-2.89%] max-w-none top-[-0.08%] w-[105.42%]" src={imgImage45} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="content-stretch flex flex-col gap-[16px] items-start relative shrink-0 w-full">
            <div className="content-stretch flex gap-[4px] items-center relative shrink-0">
              <Wrapper3>
                <g id="ix:ai">
                  <path d={svgPaths.p21edb380} fill="url(#paint0_linear_158_783)" id="Vector" />
                </g>
                <defs>
                  <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_158_783" x1="8.99999" x2="8.99999" y1="1.5" y2="16.5">
                    <stop stopColor="#0BA29B" />
                    <stop offset="1" stopColor="#43B48D" />
                  </linearGradient>
                </defs>
              </Wrapper3>
              <Text1 text="Explore AI Prompts" />
            </div>
            <div className="content-stretch flex gap-[16px] items-center overflow-clip relative shrink-0 w-full">
              <Wrapper4>
                <div className="absolute bg-[#f9fafb] h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
                  <div className="absolute h-[120px] left-0 top-0 w-[256px]" data-name="image 18">
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                      <img alt="" className="absolute h-[122.5%] left-[-0.07%] max-w-none top-[-11.67%] w-[102.08%]" src={imgImage18} />
                    </div>
                  </div>
                </div>
                <p className="absolute font-['Bricolage_Grotesque:Regular',sans-serif] font-normal h-[77px] leading-[1.8] left-[12px] text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                  An evocative image of an English afternoon tea table in a period drama setting, specifically reminiscent of the Queen ...
                </p>
                <Helper22PxText text="Retail" additionalClassNames="left-[225px]" />
              </Wrapper4>
              <Wrapper4>
                <div className="absolute bg-[#f9fafb] h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
                  <div className="absolute h-[120px] left-0 top-0 w-[256px]" data-name="image 17">
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                      <img alt="" className="absolute h-[120%] left-0 max-w-none top-[-10%] w-full" src={imgImage17} />
                    </div>
                  </div>
                </div>
                <p className="-webkit-box absolute font-['Bricolage_Grotesque:Regular',sans-serif] font-normal h-[74px] leading-[1.8] left-[12px] overflow-ellipsis overflow-hidden text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                  A charming scene depicting a rustic Italian kitchen with fresh ingredients laid out for a traditional family meal, showcasing vibrant colors and warm lighting.
                </p>
                <Helper22PxText text="Hospital" additionalClassNames="left-[210px]" />
              </Wrapper4>
              <Wrapper4>
                <div className="absolute bg-[#f9fafb] h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
                  <div className="absolute h-[120px] left-0 top-0 w-[256px]" data-name="image 16">
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                      <img alt="" className="absolute h-[120%] left-0 max-w-none top-0 w-full" src={imgImage16} />
                    </div>
                  </div>
                </div>
                <p className="-webkit-box absolute font-['Bricolage_Grotesque:Regular',sans-serif] font-normal h-[74px] leading-[1.8] left-[12px] overflow-ellipsis overflow-hidden text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                  A serene landscape featuring a Japanese zen garden, complete with meticulously raked gravel, tranquil water features, and cherry blossom trees in full bloom.
                </p>
                <Helper22PxText text="Education" additionalClassNames="left-[200px]" />
              </Wrapper4>
              <Wrapper4>
                <div className="absolute bg-[#f9fafb] h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
                  <div className="absolute h-[115px] left-0 top-[5px] w-[256px]" data-name="image 19">
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                      <img alt="" className="absolute h-[125.22%] left-0 max-w-none top-[-6.96%] w-full" src={imgImage19} />
                    </div>
                  </div>
                </div>
                <p className="-webkit-box absolute font-['Bricolage_Grotesque:Regular',sans-serif] font-normal h-[74px] leading-[1.8] left-[12px] overflow-ellipsis overflow-hidden text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                  A cozy winter cabin interior adorned with twinkling fairy lights, a crackling fireplace, and plush blankets, evoking a sense of warmth and comfort.
                </p>
                <Helper22PxText text="Retail" additionalClassNames="left-[225px]" />
              </Wrapper4>
              <Wrapper4>
                <div className="absolute bg-[#f9fafb] h-[120px] left-1/2 overflow-clip rounded-[8px] top-[12px] translate-x-[-50%] w-[256px]">
                  <div className="absolute h-[120px] left-0 top-0 w-[256px]" data-name="image 5">
                    <div className="absolute inset-0 overflow-hidden pointer-events-none">
                      <img alt="" className="absolute h-[122.5%] left-[-0.26%] max-w-none top-[-4.17%] w-[102.08%]" src={imgImage5} />
                    </div>
                  </div>
                </div>
                <p className="-webkit-box absolute font-['Bricolage_Grotesque:Regular',sans-serif] font-normal h-[75px] leading-[1.8] left-[12px] overflow-ellipsis overflow-hidden text-[#475367] text-[12px] top-[140px] tracking-[0.12px] w-[252px]" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                  A dynamic urban street art mural that captures the essence of contemporary culture, filled with bold colors and thought-provoking graffiti.
                </p>
                <Helper22PxText text="Restaurant" additionalClassNames="left-[194px]" />
              </Wrapper4>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bg-white content-stretch flex items-center left-[calc(91.67%+83px)] p-[6px] rounded-[16px] size-[32px] top-[507px]">
        <div aria-hidden="true" className="absolute border border-[#d0d5dd] border-solid inset-0 pointer-events-none rounded-[16px]" />
        <div className="flex items-center justify-center relative shrink-0 size-[20px]" style={{ "--transform-inner-width": "300", "--transform-inner-height": "150" } as React.CSSProperties}>
          <div className="flex-none rotate-[270deg]">
            <Wrapper2>
              <g id="Dropdown">
                <path d="M5 7.5L10 12.5L15 7.5" id="Icon" stroke="var(--stroke-0, #1D2739)" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
              </g>
            </Wrapper2>
          </div>
        </div>
      </div>
    </div>
  );
}
